import axios from "axios";

export interface RequestError {
    message: string; // The server's message, or "" when there is none
    status?: number; // HTTP status when the server answered (undefined = network problem)
}

// One way to read an error thrown by axios
export const toRequestError = (error: unknown): RequestError => {
    if (axios.isAxiosError<{ message?: string }>(error)) {
        return { message: error.response?.data?.message ?? "", status: error.response?.status };
    }

    return { message: error instanceof Error ? error.message : "" };
};